import { AxiosInstance } from 'axios';

import { axios } from '../../../../api/axios-instance';
import { statisticsEndpoints } from '../../../../constants';
import { DateFilter } from '../../../../enum/date-filter.enum';
import { IUserStatistics } from '../../../user/schemas/statistics.schema';

class StatisticsApi {
  #requestInstance: AxiosInstance;

  constructor(axios: AxiosInstance) {
    this.#requestInstance = axios;
  }

  getUserStatistics = async (userId: number, order: DateFilter): Promise<IUserStatistics> =>
    this.#requestInstance.get(statisticsEndpoints.StatistictsId(userId), { params: { order } });
}

export const statisticsApi = new StatisticsApi(axios);
